export default __webpack_public_path__ + "static/media/homeIntroBg.ddf36410.jpeg";